import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { Icon as m } from "@chakra-ui/react";
const i = ({
  children: n,
  title: o,
  description: c,
  ...s
}) => /* @__PURE__ */ e(m, { ...s, children: [
  o && /* @__PURE__ */ r("title", { children: o }),
  c && /* @__PURE__ */ r("desc", { children: c }),
  n
] });
export {
  i as Icon
};
//# sourceMappingURL=Icon.es.js.map
